import { render } from "./DistributionChart.vue?vue&type=template&id=4c6562d8&scoped=true"
import script from "./DistributionChart.vue?vue&type=script&lang=js"
export * from "./DistributionChart.vue?vue&type=script&lang=js"

import "@/assets/scss/_distribution.scss?vue&type=style&index=0&id=4c6562d8&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c6562d8"]])

export default __exports__